import React from "react";

const SvgWeddingReserv = (props) => {
  const fillColor = props.fill || "#16161D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2568 14.4121C22.429 14.5467 22.5409 14.7442 22.5677 14.9611C22.5945 15.1781 22.5341 15.3969 22.3997 15.5693L18.1101 21.0693C18.0345 21.1661 17.9383 21.2448 17.8284 21.2996C17.7185 21.3544 17.5977 21.384 17.4749 21.3863C17.3521 21.3885 17.2304 21.3632 17.1186 21.3124C17.0068 21.2616 16.9078 21.1864 16.8287 21.0924L14.5189 18.3424C14.4447 18.2601 14.3879 18.1638 14.3518 18.059C14.3156 17.9543 14.301 17.8434 14.3086 17.7328C14.3163 17.6223 14.3461 17.5145 14.3964 17.4157C14.4466 17.317 14.5162 17.2294 14.6011 17.1581C14.6859 17.0869 14.7842 17.0335 14.8902 17.0011C14.9961 16.9686 15.1075 16.9579 15.2177 16.9694C15.3278 16.981 15.4345 17.0146 15.5314 17.0683C15.6283 17.1221 15.7134 17.1947 15.7816 17.282L17.4359 19.251L21.0986 14.554C21.1652 14.4686 21.248 14.3971 21.3423 14.3436C21.4366 14.2902 21.5405 14.2558 21.648 14.2425C21.7556 14.2293 21.8647 14.2373 21.9692 14.2662C22.0736 14.2951 22.1713 14.3443 22.2568 14.411V14.4121Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6057 1.97586C11.836 1.83309 12.1253 1.82561 12.3627 1.9563L23.3879 8.02748C23.7508 8.22728 23.883 8.68339 23.6832 9.04623C23.4834 9.40907 23.0272 9.54124 22.6644 9.34143L12.0233 3.48183L3.60758 8.69966H4.48825C4.9024 8.69966 5.23816 9.03536 5.23825 9.44951L5.24052 20.6685C5.24061 21.0827 4.90489 21.4186 4.49067 21.4187C4.07646 21.4187 3.74061 21.083 3.74052 20.6688L3.7384 10.1997H0.974612C0.639529 10.1997 0.345101 9.97739 0.253304 9.65513C0.161508 9.33286 0.294617 8.98881 0.579404 8.81224L11.6057 1.97586Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3426 8.21757C11.6437 8.21757 11.077 8.78423 11.077 9.48338C11.077 10.1825 11.6437 10.7492 12.3426 10.7492C13.0415 10.7492 13.6083 10.1825 13.6083 9.48338C13.6083 8.78423 13.0415 8.21757 12.3426 8.21757ZM9.67696 9.48338C9.67696 8.01114 10.8704 6.81757 12.3426 6.81757C13.8149 6.81757 15.0083 8.01114 15.0083 9.48338C15.0083 10.9556 13.8149 12.1492 12.3426 12.1492C10.8704 12.1492 9.67696 10.9556 9.67696 9.48338Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export default SvgWeddingReserv;
